import { hot } from 'react-hot-loader'
import App from './components/App'

export const RootView = hot(module)(App)
